<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="logs-modal" *ngIf="screenInnerWidth >= 1000">
  <div style="background-color: #548235;  height: 7px;"></div>
  <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
    <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Event Logs for '{{currentEventNames}}'</h5>
    <button
      (click)="bsModalRef.hide()"
      class="ms-auto fas fa-times"pe="button"
      style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
    </button>
  </div>

  <div style="margin-top: 10px; margin-bottom: 5px;">
    <input (datesUpdated)="datesUpdated('')" [(ngModel)]="selectedDateRange" [alwaysShowCalendars]="true" [isInvalidDate]="isInvalidDate"
           [linkedCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCustomRangeLabel]="true" autocomplete="off"
           ngxDaterangepickerMd placeholder="Select Date Range" type="text" style="width:220px; margin-left: 10px; font-size: medium;" />
    &nbsp;
    <button (click)="datesUpdated('Today')" class="btn" style="color: rgb(0, 123, 255);" type="button">Today</button>
    <button (click)="datesUpdated('Last 2 Days')" class="btn" style="color: rgb(0, 123, 255);" type="button">Last 2 Days</button>
    <button (click)="datesUpdated('Last 7 Days')" class="btn" style="color: rgb(0, 123, 255);" type="button">Last 7 Days</button>
    <button (click)="exportEventLogTable()" class="btn btn-success" style="height: 30px; margin-right: 10px; padding-top: 1px; float: right;">Export</button>
  </div>

  <tabset>
    <p-table #eventLogTable *ngIf="eventLogs.length > 0" [columns]="eventLogCols"
             [exportFunction]="exportCsv" [value]="eventLogs" exportFilename={{exportName}} sortField="createdDate"
             sortOrder="-1" [scrollable]="true" scrollHeight="65vh">

      <!-- <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix">
          <button (click)="eventLogTable.exportCSV()" class="btn btn-success" style="height: 30px; margin-left: 20px; margin-right: 10px; padding-top: 1px;">Export</button>
        </div>
      </ng-template> -->

      <ng-template let-columns pTemplate="header">
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field"  [ngStyle]="{'width': col.width}" class="text-center" style="background-color: var(--kig-section-header-bg); flex: none;">
            {{col.header}}
            <p-sortIcon *ngIf="col.header!='' && col.header!='Condition(s)'" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template let-columns="columns" let-rowData pTemplate="body">
        <tr>
          <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
            {{ rowData.eventName }}
          </td>

          <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
            {{rowData.createdDate | date : 'medium'}}
          </td>

          <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
            <table style="width: 100%;">
              <tr *ngFor = "let conditionResult of rowData.conditionResults">
                <td width="80%">
                  {{conditionResult.text}}
                </td>
                <td width="20%">
                  <div *ngIf="conditionResult.parentType == 'Sensor Based'">
                    <div (click)="showSensorReadingsUsedInCalculation(rowData, conditionResult, sensorReadingsUsedTemplate)" style="cursor: pointer; color: rgb(0, 123, 255);">
                      {{conditionResult.value}}
                    </div>
                  </div>
                  <div *ngIf="conditionResult.parentType != 'Sensor Based'">
                    <div [ngStyle]="{'color': common.getEventLogResultColor(conditionResult.value)}">
                      {{conditionResult.value}}
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </td>

          <td [ngStyle]="{'width': columns[3].width}" class="text-center" style="flex: none; border-width: 0px;">
            <div *ngFor="let actionResult of rowData.actionResults">
              <div [ngStyle]="{'background-color': common.getEventLogColor(actionResult.value)}">
                {{actionResult.text}}
              </div>
            </div>
          </td>

        </tr>
      </ng-template>
    </p-table>
  </tabset>
</div>

<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content"  *ngIf="screenInnerWidth < 1000">
<!-- <div *ngIf="screenInnerWidth < 1000" class="modal-content"> -->
  <div style="background-color: #548235;  height: 7px;"></div>
  <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
    <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Event Logs for '{{currentEventNames}}'</h5>
    <!-- <button (click)="logModalRef.hide()" aria-label="Close" class="close pull-right" type="button"><span
      aria-hidden="true">&times;</span></button> -->
    <button
      (click)="bsModalRef.hide()"
      class="ms-auto fas fa-times"pe="button"
      style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
    </button>
  </div>

  <div class="text-center">
    <input (datesUpdated)="datesUpdated('')" [(ngModel)]="selectedDateRange" [alwaysShowCalendars]="true" [isInvalidDate]="isInvalidDate"
           [linkedCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCustomRangeLabel]="true" autocomplete="off" 
           ngxDaterangepickerMd placeholder="Select Date Range" type="text" style="width:220px; margin-left: 10px; margin-top: 5px; font-size: medium;" />
  </div>
  <div class="text-center">
    <button (click)="datesUpdated('Today')" class="btn" style="color: rgb(0, 123, 255);" type="button">Today</button>
    <button (click)="datesUpdated('Last 2 Days')" class="btn" style="color: rgb(0, 123, 255);" type="button">Last 2 Days</button>
    <button (click)="datesUpdated('Last 7 Days')" class="btn" style="color: rgb(0, 123, 255);" type="button">Last 7 Days</button>
  </div>

  <div class="row card-group justify-content-center">
    <div *ngFor="let rowData of eventLogs; let index=index;" style="width: 325px;">
      <div class="card bg-light mb-3" style="max-width: 22rem; margin-right: 15px">
        <div class="card-header" style="background-color: var(--kig-section-header-bg); padding: 0.5rem">
          <h5 class="card-title" style="margin-bottom: 0rem;">
            {{rowData.createdDate | date : 'medium'}}
          </h5>
        </div>
        <div class="card-body" style="padding: 0.3rem">
          <table>
            <tr>
              <td width="75%" class="text-center">
                <table style="width: 100%;">
                  <tr *ngFor = "let conditionResult of rowData.conditionResults">
                    <td width="75%">
                      {{conditionResult.text}}
                    </td>
                    <td width="25%">
                      <div *ngIf="conditionResult.parentType=='Sensor Based'">
                        <div (click)="showSensorReadingsUsedInCalculation(rowData, conditionResult, sensorReadingsUsedTemplate)" style="cursor: pointer; color: rgb(0, 123, 255);">
                          {{conditionResult.value}}
                        </div>
                      </div>
                      <div *ngIf="conditionResult.parentType!='Sensor Based'">
                        <div [ngStyle]="{'color': common.getEventLogResultColor(conditionResult.value)}">
                          {{conditionResult.value}}
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
              <td width="25%" class="text-center" >
                <div *ngFor="let actionResult of rowData.actionResults">
                  <div [ngStyle]="{'background-color': common.getEventLogColor(actionResult.value)}">
                    {{actionResult.text}}
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>

</div>


<ng-template #sensorReadingsUsedTemplate>
  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="eventSensorReadings-modal shadow-lg bg-white rounded" *ngIf="screenInnerWidth >= 1000">
  <!-- <div *ngIf="screenInnerWidth >= 1000" class="modal-content eventSensorReadings-modal shadow-lg bg-white rounded"> -->
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
      <h5 style="color: rgb(10, 10, 10); text-transform: none;">Sensor Readings Used in Calculation</h5>
      <!-- <button (click)="sensorReadingModalRef.hide()" aria-label="Close" class="close pull-right" type="button"><span
        aria-hidden="true">&times;</span></button> -->
      <button
        (click)="sensorReadingModalRef.hide()"
        class="ms-auto fas fa-times"pe="button"
        style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
      </button>
    </div>

    <div class="modal-body">
      <p-table #eventLogSensorReadingsTable *ngIf="currentEventLogSensorReadings.length > 0" [columns]="eventLogSensorReadingCols" [value]="currentEventLogSensorReadings" sortField="uuid" sortOrder="-1">

        <ng-template let-columns pTemplate="header">
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="text-center" style="background-color: var(--kig-section-header-bg);">
              {{col.header}}
              <p-sortIcon *ngIf="col.header!='' && col.header !='Created Date'" [field]="col.field"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template let-columns="columns" let-rowData pTemplate="body">
          <tr>
            <td class="text-center">
              {{rowData.uuid}}
            </td>
            <td class="text-center">
              {{rowData.value}}
            </td>
            <td class="text-center">
              {{rowData.createdDate | date : 'medium'}}
            </td>

          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="shadow-lg bg-white rounded" *ngIf="screenInnerWidth < 1000">
  <!-- <div *ngIf="screenInnerWidth < 1000" class="modal-content shadow-lg bg-white rounded"> -->
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
      <h5 style="color: rgb(10, 10, 10); text-transform: none;">Sensor Readings Used</h5>
      <!-- <button (click)="sensorReadingModalRef.hide()" aria-label="Close" class="close pull-right" type="button"><span
        aria-hidden="true">&times;</span></button> -->
      <button
        (click)="sensorReadingModalRef.hide()"
        class="ms-auto fas fa-times"pe="button"
        style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
      </button>
    </div>

    <div class="modal-body">
      <div class="row card-group justify-content-center">
        <div *ngFor="let rowData of currentEventLogSensorReadings; let index=index;" style="width: 325px;">
          <div class="card bg-light mb-3" style="max-width: 22rem; margin-right: 15px">
            <div class="card-header" style="background-color: var(--kig-section-header-bg); padding: 0.5rem">
              <h5 class="card-title" style="margin-bottom: 0rem;">
                {{rowData.createdDate | date : 'medium'}}
              </h5>
            </div>
            <div class="card-body" style="padding: 0.3rem">
              <table style="width: 100%;">
                <tr>
                  <td class="text-center">
                    ...{{ rowData.uuid | slice:-8 }}
                  </td>
                  <td class="text-center">
                    {{rowData.value}}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</ng-template>
